import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  type ClientTrainingProgramDetails,
  type ProgramWorkout,
} from "@fitness-app/data-models/entities/TrainingProgram";

import { type AsyncThunkCreator } from "../../../index";
import { updateWorkoutsInProgram } from "../reducer";
import { getCurrentTraineeProgram } from "../selectors/getCurrentProgram";
import { TRAINEE_PROGRAM_REDUCER_NAME } from "../types";

type Payload = {
  programId: string;
  workoutId: string;
  workout: Partial<ProgramWorkout>;
};

export const updateWorkoutMetadata = createAsyncThunk<ClientTrainingProgramDetails, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_PROGRAM_REDUCER_NAME}/updateWorkoutMetadata`,
  async ({ programId, workout, workoutId }, { rejectWithValue, getState, dispatch, extra: { db } }) => {
    const currentProgram = getCurrentTraineeProgram(getState());

    const updatedWorkouts = currentProgram.details.workouts.map((savedWorkout) =>
      savedWorkout.id === workoutId ? { ...savedWorkout, ...workout } : savedWorkout,
    );

    dispatch(updateWorkoutsInProgram({ workouts: updatedWorkouts, programId }));

    const { data: programDetails, error } = await db
      .from("client_training_program_details")
      .update({
        workouts: updatedWorkouts,
        updatedAt: new Date().toISOString(),
      })
      .eq("programId", programId)
      .select()
      .single<ClientTrainingProgramDetails>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return programDetails;
  },
);
